// material-ui
import { Margin } from '@mui/icons-material';
import Box from '@mui/material/Box';

// project import
import MainCard, { MainCardProps } from 'ui-component/cards/MainCard';
import { styled, Theme } from '@mui/material/styles';
import { useTheme } from '@mui/material/styles';

// ==============================|| AUTHENTICATION CARD WRAPPER ||============================== //

const AuthCardWrapper = ({ cardWidth, children, ...other }: MainCardProps) => {
    const theme = useTheme();
    return (
        <MainCard
            sx={{
                maxWidth: { xs: 400, lg: cardWidth ? parseInt(cardWidth) : 475 },
                margin: { xs: 1, md: 3 },
                bgcolor: '#fff',
                '& > *': {
                    flexGrow: 1,
                    flexBasis: '50%',
                    bgcolor: '#fff'
                },
                [theme.breakpoints.down('sm')]: {
                    maxWidth:'95%',
                },
            }}
            content={false}
            {...other}
        >
            <Box sx={{ p: { xs: 0, sm: 0, xl: 0 } }}>{children}</Box>
        </MainCard>
    );
};

export default AuthCardWrapper;
